import { enableProdMode } from "@angular/core";
import { ENVIRONMENT } from "./environments/environment";
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (ENVIRONMENT.env === 'production') {
    enableProdMode();
} // end if
const init = () => {
    __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
        .then(() => window.appBootstrap && window.appBootstrap())
        .catch(OBJ_error => console.error("Bootstrap Error =>", OBJ_error));
};
const ɵ0 = init;
// init on first load
init();
export { ɵ0 };
